// Module
var code = "<icon-warning class=\"custom-warning-icon\"></icon-warning> ";
// Exports
module.exports = code;